<ng-template
    #content
    let-modal
>
    <div class="modal-header">
        <h4
            class="modal-title"
            [innerHtml]="title"
        ></h4>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="close()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <ng-container *ngIf="isLinkDisplay; then linkDisplay else htmlContent"></ng-container>
    <ng-template #htmlContent>
        <div
            class="modal-body"
            [innerHTML]="body | safe:'html'"
        ></div>
    </ng-template>
    <ng-template #linkDisplay>
        <div class="modal-body">
            <a (click)="clickLink.emit()">{{ body }}</a>
        </div>
    </ng-template>
    <div class="modal-footer">
        <ng-container *ngIf="isConfirm; then yesNoButtons; else okButton"></ng-container>
        <ng-template #okButton>
            <button
                type="button"
                class="btn btn-primary"
                name="okBtn"
                (click)="clickedPositive()"
            >
                OK
            </button>
        </ng-template>
        <ng-template #yesNoButtons>
            <button
                type="button"
                class="btn btn-primary"
                name="yesBtn"
                (click)="clickedPositive()"
            >
                Yes
            </button>
            <button
                type="button"
                class="btn btn-outline-dark"
                name="noBtn"
                (click)="clickedDismiss()"
            >
                No
            </button>
        </ng-template>
    </div>
</ng-template>
